/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pay_Overdue_InvoiceInputs */



/**
* | output |
* | --- |
* | "Pay Overdue Invoice" |
*
* @param {Pay_Overdue_InvoiceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pay_overdue_invoice = /** @type {((inputs?: Pay_Overdue_InvoiceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pay_Overdue_InvoiceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Payer la facture en retard")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überfällige Rechnung bezahlen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pagare la fattura in ritardo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оплатить просроченный счет")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pagar factura vencida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("支付逾期发票")
	if (locale === "ja") return /** @type {LocalizedString} */ ("支払期限を過ぎた請求書の支払い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बकाया बिल का भुगतान करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pagar fatura vencida")
	return /** @type {LocalizedString} */ ("Pay Overdue Invoice")
});